import Image1 from '../../../img/html-1.svg'
import Image2 from '../../../img/css-3.svg'
import Image3 from '../../../img/logo-javascript.svg'
import Image4 from '../../../img/react-2.svg'
import Image5 from '../../../img/next-js.svg'
import Image6 from '../../../img/git-icon.svg'

import Image11 from '../../../img/python.svg'
import Image12 from '../../../img/django.svg'
import Image13 from '../../../img/postgresql.svg'
import Image14 from '../../../img/mysql-6.svg'
import Image15 from '../../../img/linux.svg'
import Image16 from '../../../img/nodejs.svg'



export const SkillFrontEnd = [
    {
        Image:Image1,
        NameSkill:'Html',
        SubNameSkill:'Advanced',
    },
    {
        Image:Image2,
        NameSkill:'Css',
        SubNameSkill:'Advanced',
    },
    {
        Image:Image3,
        NameSkill:'JavaScript',
        SubNameSkill:'Intermediate',
    },
    {
        Image:Image4,
        NameSkill:'React',
        SubNameSkill:'Intermediate',
    },
    {
        Image:Image5,
        NameSkill:'NextJs',
        SubNameSkill:'Intermediate',
    },
    {
        Image:Image6,
        NameSkill:'Git',
        SubNameSkill:'Intermediate',
    },
]

export const SkillBackEnd = [
    {
        Image:Image11,
        NameSkill:'Python',
        SubNameSkill:'Advanced',
    },
    {
        Image:Image12,
        NameSkill:'Django',
        SubNameSkill:'Intermediate',
    },
    {
        Image:Image13,
        NameSkill:'Postgresql',
        SubNameSkill:'Basic',
    },
    {
        Image:Image14,
        NameSkill:'MySql',
        SubNameSkill:'Basic',
    },
    {
        Image:Image15,
        NameSkill:'Linux',
        SubNameSkill:'Intermediate',
    },
    {
        Image:Image16,
        NameSkill:'NodeJs',
        SubNameSkill:'Intermediate',
    },
]